var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturnDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6865 13.2764L28.876 14.6797H21.5674V14.6846H12.626L15.2822 19.2402H11.8096L8.7207 13.9404L8.27637 13.1787L8.72559 12.4209L11.7793 7.26953H15.2666L12.6484 11.6846H25.3027L20.5322 3.42188L9.15332 3.4209L3.46387 13.2764L9.15332 23.1299H20.5322L23.1006 18.6797H26.5664L22.2646 26.1309H7.42188L0 13.2764L7.42188 0.421875H22.2646L29.6865 13.2764Z",
    fill: "#DFF8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnDashboardIcon);
export default __webpack_public_path__ + "static/media/return-dashboard-icon.fdceaf35aad1cd97c10bea97ace1c89c.svg";
export { ForwardRef as ReactComponent };